import { useApolloClient } from '@apollo/client';
import {
  ArticleListItemNodeFragment,
  ArticleListItemNodeFragmentDoc,
  ArticleNodeFragment,
  ArticleNodeFragmentDoc,
} from 'lib-knowledge-management-common/graphql';

/** Fetch an articles details from the cache. */
export function useArticleCacheFetch({
  articleId,
}: {
  articleId: string;
}): ArticleNodeFragment | null {
  const { cache } = useApolloClient();

  const article = cache.readFragment<ArticleNodeFragment>({
    fragment: ArticleNodeFragmentDoc,
    id: cache.identify({
      __typename: 'Article',
      id: articleId,
    }),
  });

  if (article) return article;

  const articleListItem = cache.readFragment<ArticleListItemNodeFragment>({
    fragment: ArticleListItemNodeFragmentDoc,
    id: cache.identify({
      __typename: 'ArticleListItem',
      id: articleId,
    }),
  });

  if (articleListItem) {
    return {
      __typename: 'Article',
      id: articleListItem.id,
      titles: articleListItem.titles,
      // @ts-expect-error the typename is different but the structure the same
      parent: articleListItem.parentCategories?.[0],
    };
  }

  return null;
}
